import { LoadingButton } from '@atlaskit/button';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import {
  AkCheckCircleOutlineIcon,
  AkSelectClearIcon,
} from '@fuegokit/fuegoicons-react';
import { AtlasButton, Box, Text } from '@fuegokit/react';
import React, { useState } from 'react';

import { useTogglAccountContext } from '../../screens/ToggleAccountTokenProvider';

function WarningIcon() {
  return (
    <Box
      sx={{
        color: 'icon.warning.default',
      }}
    >
      <AkSelectClearIcon />
    </Box>
  );
}

export function ConnectionStatus() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { removeToken } = useTogglAccountContext();

  const onConfirm = async () => {
    setIsLoading(true);
    await removeToken();
    setIsLoading(false);
    setIsModalOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '2',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '1',
            alignItems: 'center',
          }}
        >
          <Box sx={{ color: '#36B37E' }}>
            <AkCheckCircleOutlineIcon size={32} />
          </Box>
          <Text color="text.default">You are connected to Toggl.</Text>
        </Box>
        <AtlasButton appearance="default" leadingIcon={WarningIcon}>
          <Box sx={{ marginLeft: '1' }} onClick={() => setIsModalOpen(true)}>
            Disconnect token
          </Box>
        </AtlasButton>
      </Box>
      <ModalTransition>
        {isModalOpen && (
          <Modal>
            <ModalHeader>
              <ModalTitle appearance="warning">
                Disconnect Toggle account
              </ModalTitle>
            </ModalHeader>
            <ModalBody>
              By confirming you will reset token and your account will be
              detached from Toggle for Jira
            </ModalBody>
            <ModalFooter>
              <AtlasButton
                appearance="subtle"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </AtlasButton>
              <LoadingButton
                appearance="warning"
                isLoading={isLoading}
                onClick={() => void onConfirm()}
              >
                Confirm
              </LoadingButton>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    </>
  );
}
